export default __webpack_public_path__ + "static/media/idea.ac1f9534.svg";